/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React from 'react';
import './Loader.css';


function Loader() {
    return (
        <div className="loader-overlay">
            <div className="spinner-border text-primary">
                <output className="visually-hidden">Loading...</output>
            </div>
        </div>
    );
}

export default Loader;
